import { useState } from "react";
import { Event } from "../types/event.types";
import { sendPostMessage } from "../utils/postMessage";

export const useCloseConfirmation = (onClose?: () => void) => {
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const handleCloseClick = () => {
    setShowCancelConfirm(true);
  };

  const handleConfirm = () => {
    // Send close event to parent window
    sendPostMessage({
      status: Event.CLOSE,
      message: "close iframe"
    });

    setShowCancelConfirm(false);

    // Call optional onClose callback if provided
    if (onClose) {
      onClose();
    }
  };

  const handleModalClose = () => {
    setShowCancelConfirm(false);
  };

  return {
    showCancelConfirm,
    handleCloseClick,
    handleConfirm,
    handleModalClose
  };
};
